import React, { useState } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { ScienceContainer, Wrapper } from "./styles"
import { Row, Col } from "react-bootstrap"
import scienceWaves from "../../img/science_waves.svg"

const ScienceElementsSelector = ({ item }) => {
  // get elements data
  const data = useStaticQuery(COMPOUNDS_QUERY)

  // // set state of current image
  const [bodyImage, setBodyImage] = useState(item.customFields.initialImage.url)

  // get compounds list
  const compoundsList = data.allAgilityCompound.edges

  return (
    <ScienceContainer img={scienceWaves}>
      <Wrapper>
        <h1>{item.customFields.title}</h1>
        <Row>
          <Col lg={6} md={6}>
            <ul>
              <Row>
                {compoundsList.map((compound, i) => (
                  <Col lg={6} key={i}>
                    <li>
                      <Link to={compound.node.sitemapNode.path}>
                        <button
                          onMouseEnter={() =>
                            setBodyImage(compound.node.customFields.image.url)
                          }
                          onMouseLeave={() =>
                            setBodyImage(item.customFields.initialImage.url)
                          }
                        >
                          {compound.node.customFields.button}
                        </button>
                      </Link>
                    </li>
                  </Col>
                ))}
              </Row>
            </ul>
          </Col>
          <Col lg={6}>
            <img src={bodyImage} alt="Compounds Diagram" />
          </Col>
        </Row>
      </Wrapper>
    </ScienceContainer>
  )
}

export const COMPOUNDS_QUERY = graphql`
  query {
    allAgilityCompound(filter: { customFields: { button: { ne: null } } }) {
      edges {
        node {
          customFields {
            button
            image {
              url
              label
            }
          }
          sitemapNode {
            path
          }
        }
      }
    }
  }
`

export default ScienceElementsSelector
